export default {
    // A
    addFiles: 'Add files',
    authorization: 'Authorization',

    // B
    box: 'Box',

    // D
    dropFilesToUpload: 'Drop files to upload',
    loaderSubtext: 'Drag and drop your files here or click the',
    loaderSubtextMore: `'Add files' button to browse your computer`,

    // S
    selectThumbnail: 'Select thumbnail',
    startUpload: 'Start Upload',
    subtitle: 'Choose a title for your video that will appear on the title card during your video, making sure to keep it short, descriptive, and easy for your viewers to understand.',

    // U
    uploadCSV: 'Upload CSV',
    uploads: 'Uploads',
}
